import React from 'react';

import { Row, Col, Typography } from 'antd';

const { Text } = Typography;

const SecurityItemContainer = (props) => {
  const { children, title } = props;

  return (
    <div className='user-security-tab__item'>
      <Row>
        <Col xs={24} className='user-security-tab__item-title'>
          <Text strong>{title && title}</Text>
        </Col>
      </Row>
      {children}
    </div>
  );
};

export default SecurityItemContainer;
